import React from 'react';
import { Route } from 'react-router-dom';
import { GlobalConsumer } from '../context/GlobalProvider';
import ModalComplete from '../components/extensions/modal/ModalComplete';
import GlobalLoader from '../components/common/loader/GlobalLoader';
import Welcome from '../components/extensions/welcome/Welcome';
import SplashScreen from '../components/common/splash-screen/SplashScreen';
import Toast from '../components/ui/toast/Toast';

const RouteDefault = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      <GlobalConsumer>
        {context => {
          return (
            <>
              <Component {...props} context={context} />
              <ModalComplete context={context} />
              <GlobalLoader context={context} />
              <SplashScreen context={context} />
              <Welcome context={context} />
              <Toast />
            </>
          );
        }}
      </GlobalConsumer>
    )}
  />
);

export default RouteDefault;
